import NextImage from "@/app/components/lib/NextImage";
import { useRouter } from "@/app/components/lib/navigation/useRouter";
import React from "react";

interface props {
  src: string;
}
const ImgSmall: React.FC<props> = ({ src }) => {
  const router = useRouter();
  return (
    <div className="img pc" onClick={() => router.push("/cart")}>
      <NextImage src={src} alt="product" objectFit="cover" priority />
    </div>
  );
};

export default ImgSmall;
